module.exports = __webpack_public_path__ + "media/country_flags/gs-392a2e67.png";